module.exports = __webpack_public_path__ + "img/Lukose Antony.9109b924.jpeg";